import { connect, MapStateToProps } from 'react-redux';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import { getIsDuperbrowseActive } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';
import { getPagingMode } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../../../../types/store';
import { getCurrentPage, getTotalPages } from '../../../../selectors/pageInfo';

import { Props } from './StreamPagination';

export type StateProps = Pick<
  Props,
  'isDuperbrowseActive' | 'isInfiniteScroll' | 'requestUrl' | 'currentPage' | 'totalPages' | 'error'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => {
  return {
    requestUrl: getEnv(state).requestUrl,
    isDuperbrowseActive: getIsDuperbrowseActive(state as any),
    isInfiniteScroll: getPagingMode(state) === 'scroll',
    currentPage: getCurrentPage(state),
    totalPages: getTotalPages(state),
  };
};

export default connect(mapStateToProps);
